/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import './Collapse.css';

import { Collapse as AntDCollapse } from 'antd';

export type CollapseProps = {
  items: { key: string; label: React.ReactNode; children: React.ReactNode }[];
  style?: React.CSSProperties;
  bordered?: boolean;
};

export function Collapse({ items, style, bordered }: CollapseProps) {
  const className = bordered === true || bordered === undefined ? 'mimic-collapse-bordered' : 'mimic-collapse';
  return <AntDCollapse ghost items={items} style={{ ...style }} className={className} />;
}
